import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
// eslint-disable-next-line @emotion/no-vanilla
import { cache } from 'emotion';
import { CacheProvider } from '@emotion/core';
import { UserContextProvider } from '@ordermentum/ui-shared/utilities/UserContextProvider';
import { ThemeContext } from '@ordermentum/ui-shared/utilities/theme';
import store from './redux/store';
import routes from './routes';
import { history } from './lib/history';
import '@ordermentum/ui-shared/middleware/user_context';

const renderNode = document.getElementById('root');
if (renderNode) {
  ReactDOM.render(
    <CacheProvider value={cache}>
      <Provider store={store}>
        <ThemeContext.Provider value="futuro">
          <UserContextProvider>
            <Router history={history} routes={routes} />
          </UserContextProvider>
        </ThemeContext.Provider>
      </Provider>
    </CacheProvider>,
    renderNode
  );
}
